export default "__VITE_ASSET__22e9542e__"